import { useEffect, useRef, useState, useCallback } from 'react';
import useEventListener from './useEventListener';

const CLICK_EVENT_NAME = "click";
const CHR_CUSTOM_CLICK_EVENT_NAME = "chrCustomClick";

const chrCustomClickEvent = () => {
  return new CustomEvent(CHR_CUSTOM_CLICK_EVENT_NAME, {
    view: window,
    bubbles: true,
    cancelable: true
  });
};

export const dispatchChrCustomClickEventFor = event => {
  event.target.dispatchEvent(chrCustomClickEvent());
};

const useToggler = (props = {}) => {
  const showByDefault = !!(props && props.showByDefault);
  const [showContent, setShowContent] = useState(showByDefault);
  const contentRef = useRef(null);
  const extraClickableContentRef = props.extraClickableContentRef;

  // NOTE: For useToggler to effectively toggle the current element, it needs to be aware of every click event taking place in the DOM. If you are suppressing clicks in a few components, be sure to dispatch the 'chrCustomClick' event to inform useToggler that a click was made inside a component that was suppressed.
  const eventsToRegister = [CLICK_EVENT_NAME, CHR_CUSTOM_CLICK_EVENT_NAME];

  const handleClickOutside = useCallback((event) => {
    const content = contentRef.current;
    const extraContent = extraClickableContentRef?.current;
  
    const clickedOutsideContent = content && !content.contains(event.target);
    const clickedOutsideExtraContent = extraContent ? !extraContent.contains(event.target) : true;
  
    if (clickedOutsideContent && clickedOutsideExtraContent) {
      setShowContent(false);
    }
  }, [contentRef, extraClickableContentRef, setShowContent]);

  // Adding click event listeners during component mounting and removing it during component unmounting
  useEffect(() => {
    eventsToRegister.map(eventName => useEventListener({ event: eventName, callback: handleClickOutside, useCapture: props.useCapture }));
    return () => {
      eventsToRegister.map(eventName => useEventListener({ event: eventName, callback: handleClickOutside, action: "remove", useCapture: props.useCapture }));
    };
  }, []);

  const showContentToggler = () => {
    if (props.openFollowups && !showContent) props.openFollowups()
    setShowContent(!showContent);
  };

  return ({
    showContent,
    setShowContent,
    contentRef,
    showContentToggler
  });
};

export default useToggler;